import React from 'react';
import {useEffect, useState} from 'react';
import ThingToDoCard from './ThingToDoCard';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';
import {
  ISOToDisplayDate,
  evaluateOperator,
  ENTITY_TYPE_NAME_MAP,
  getActionVal,
} from 'common/utils';
import REST from 'go/requests/rest';
import _ from 'lodash';

const ThingsToDoResults = ({thingsToDo, isOnlySubRecipient, setRedirect, props}) => {
  const [thingsToDoWithActionVals, setThingsToDoWithActionVals] = useState([]);
  useEffect(() => {
    const anyFunction = async () => {
      setThingsToDoWithActionVals(
        await getActionVal(props.permissions, props.token, thingsToDo)
      );
    };
    anyFunction();
  }, [thingsToDo]);
  return (
    <>
      {thingsToDoWithActionVals.map((thing) => {
        const isPastDueValue = ISOToDisplayDate(thing.dueDate, {
          showDate: true,
          fromUnix: true,
        });
        const isPastDue = evaluateOperator('isPastDate', isPastDueValue);
        const actionValLink = thing.actionVal ? (
          <a href={thing.actionVal}>Continue</a>
        ) : (
          ''
        );
        const entityNameTitle = thing.subGrantId
          ? 'Subgrant ID'
          : thing.payload &&
            thing.payload.scopeOfWork &&
            thing.payload.scopeOfWork.proposedActivityTitle
          ? 'Title'
          : 'Grant ID';
        const entityNameValue = thing.subGrantId
          ? thing.subGrantId
          : thing.payload &&
            thing.payload.scopeOfWork &&
            thing.payload.scopeOfWork.proposedActivityTitle
          ? thing.payload.scopeOfWork.proposedActivityTitle
          : thing.grantId;
        const foNameLink = (
          <a
            key={`link-${thing.fundingOpportunityName}`}
            href="#"
            title={`View funding opportunity: ${thing.fundingOpportunityName}`}
            onClick={(e) => {
              e.preventDefault();
              if (!isOnlySubRecipient)
                new Promise((resolve) => resolve()).then((res) => {
                  setRedirect(`/fundingOpportunity/${thing.fundingOpportunityId}`);
                });
            }}
          >
            {thing.fundingOpportunityName}
          </a>
        );

        const typeValue =
          thing.entityType === 'subApplication'
          && thing.payload 
          && thing.payload.applicationTypeDescription
            ? `${thing.payload.applicationTypeDescription} Subapplication`
            : ENTITY_TYPE_NAME_MAP[thing.entityType];
        const cardContents = thing.subOrganizationName
          ? [
              {
                name: 'Funding Opportunity Name',
                value: foNameLink,
                isPastDue: isPastDue,
              },
              {
                name: 'Type',
                value: typeValue,
              },
              {
                name: entityNameTitle,
                value: entityNameValue,
              },
              {
                name: 'Status',
                value: ASSOCIATED_ENTITY_STATUSES[thing.status],
              },
              {
                name: 'Recipient',
                value: thing.organizationName,
              },
              {
                name: 'Subrecipient',
                value: thing.subOrganizationName,
              },
              {
                name: 'Due Date',
                value: isPastDueValue,
                isPastDue: isPastDue,
              },
              {
                name: 'Action',
                value: actionValLink,
              },
            ]
          : [
              {
                name: 'Funding Opportunity Name',
                value: foNameLink,
                isPastDue: isPastDue,
              },
              {
                name: 'Type',
                value: ENTITY_TYPE_NAME_MAP[thing.entityType],
              },
              {
                name: entityNameTitle,
                value: entityNameValue,
              },
              {
                name: 'Status',
                value: ASSOCIATED_ENTITY_STATUSES[thing.status],
              },
              {
                name: 'Recipient',
                value: thing.organizationName,
              },
              {
                name: 'Due Date',
                value: isPastDueValue,
                isPastDue: isPastDue,
              },
              {
                name: 'Action',
                value: actionValLink,
              },
            ];
        const cardWidth = thing.subOrganizationName ? 2 : 2.5;
        return <ThingToDoCard cardContents={cardContents} cardWidth={cardWidth} />;
      })}
    </>
  );
};

export default ThingsToDoResults;
